import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CsvExportService {

  /**
   
   * @param filename - Name of the file (without .csv extension)
   * @param data - Array of objects to export
   * @param columns - Optional: specific columns to export. If not provided, exports all object keys
   * @param customHeaders - Optional: custom header labels to display instead of column names
   */
  exportToCsv<T extends Record<string, unknown>>(filename: string, data: T[], columns?: string[], customHeaders?: string[]): void {
    if (!data || data.length === 0) {
      console.warn('No data to export');
      return;
    }

    // Determine columns to export
    const exportColumns = columns || Object.keys(data[0]);

    const header = customHeaders && customHeaders.length === exportColumns.length
      ? customHeaders.join(',')
      : exportColumns.join(',');

    // Create data rows
    const rows = data.map(record => {
      return exportColumns.map(column => {
        const value = record[column];
        return this.formatCsvCell(value);
      }).join(',');
    });

    
    const csvContent = [header, ...rows].join('\n');

    
    this.downloadCsv(csvContent, `${filename}.csv`);
  }


  private formatCsvCell(value: unknown): string {
    if (!value) {
      return '';
    }

    let cellValue = typeof value === 'object'
      ? JSON.stringify(value)
      : String(value);


    cellValue = cellValue.replace(/"/g, '""');

    
    if (/[",\n\r]/.test(cellValue)) {
      cellValue = `"${cellValue}"`;
    }

    return cellValue;
  }


  private downloadCsv(content: string, filename: string): void {
    
    const bom = '\uFEFF';
    const blob = new Blob([bom + content], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();

    
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}
